// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";
import styled from "styled-components";

const Container = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  padding-left: 35px;
  transform: scale(calc(${props => props.theme.fontSizes.base} / 24));
  transform-origin: center left;
  height: 24px;
  cursor: pointer;
  font-size: 24px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 24px;
    width: 24px;
    background-color: transparent;
    border: 2px solid ${props => props.theme.grayscale?.g60};
    border-radius: 4px;
    &:hover {
      border: 2px solid ${props => props.theme.grayscale?.g90};
    }
    &:focus {
      border: 2px solid ${props => props.theme.grayscale?.g90};
    }
    transition: all ${props => props.theme.transitions.quick} ease;
  }

  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
    transition: all ${props => props.theme.transitions.quick} ease;
  }

  input:checked ~ .checkmark {
    border: 2px solid ${props => props.theme.colors.primary};
  }

  input:checked ~ .checkmark:after {
    display: block;
  }

  .checkmark:after {
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid ${props => props.theme.colors.primary};
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

const Checkbox = (props: any) => (
  <Container {...props}>
    Label for checkbox
    <input type="checkbox" />
    <span className="checkmark"></span>
  </Container>
);

export default Checkbox;
